export const GIANTS_UNIT_MAX_SIZE = 99;

export const GIANTS_ADDITIONAL_SUPPLY_COST = 4;

export const GIANTS_D20_SAME_TYPE_UNIT_LIMIT = 4;

export const GIANTS_UNIT_WIN_POINTS = 5;

// Иконка великана на поле крупнее стандартной иконки отряда на 10%
// (множитель к UNIT_SCALE_MULTIPLIER/FACTION_UNIT_SCALE_MULTIPLIER,
// см. renderUnit в HexGridRenderer)
export const GIANTS_UNIT_ICON_SCALE_MULTIPLIER = 1.2;
